import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class glitch {

    constructor() {
        this._init();
    }


    _init() {
        this._setupGlitchElmClone();

        setTimeout(() => {
            this._onScroll();
        }, 1000);
    }

    /**
     * グリッチ用の要素をcloneしてDOMに追加
     */
    _setupGlitchElmClone() {
        document.querySelectorAll(".c-glitch").forEach((elm) => {
            const targetElm = elm.querySelector(".c-glitch__target");
            if (!targetElm) return;

            const cloneElm = targetElm.cloneNode(true);
            elm.appendChild(cloneElm);
        });
    }

    _onScroll() {
        const revealElm = [...document.querySelectorAll(".js-scrolleffect")];

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 85%",
                //markers: true,
                onEnter: () => {
                    el.classList.add("-inview");
                },
            });
        });
    }

}